module.exports = __webpack_public_path__ + "static/media/value_prop_img_2.77f809ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value_prop_img_2.jpg
// module id = 1415
// module chunks = 0